(function () {
  'use strict';
  /* ── i18n from Liquid ───────────────────────────────────────── */
  var i18nEl = document.getElementById('hwl-i18n');
  var i18n = {
    addToWishlist: i18nEl ? i18nEl.dataset.addToWishlist : 'Add to wishlist',
    savedToWishlist: i18nEl ? i18nEl.dataset.savedToWishlist : 'Saved',
    removeFromWishlist: i18nEl ? i18nEl.dataset.removeFromWishlist : 'Remove from wishlist',
    wishlistTitle: i18nEl ? i18nEl.dataset.wishlistTitle : 'Wishlist',
    wishlistLogin: i18nEl ? i18nEl.dataset.wishlistLogin : 'Log in to save your wishlist',
    wishlistFilter: i18nEl ? i18nEl.dataset.wishlistFilter : 'Filter',
    wishlistItemCount: i18nEl ? i18nEl.dataset.wishlistItemCount : 'items',
    wishlistSortLabel: i18nEl ? i18nEl.dataset.wishlistSortLabel : 'Sort by:',
    wishlistSortRecommend: i18nEl ? i18nEl.dataset.wishlistSortRecommend : 'Recommended',
    wishlistSortNewest: i18nEl ? i18nEl.dataset.wishlistSortNewest : 'Newest',
    wishlistSortPriceAsc: i18nEl ? i18nEl.dataset.wishlistSortPriceAsc : 'Price: Low to High',
    wishlistSortPriceDesc: i18nEl ? i18nEl.dataset.wishlistSortPriceDesc : 'Price: High to Low',
    wishlistViewLabel: i18nEl ? i18nEl.dataset.wishlistViewLabel : 'View',
    wishlistEmpty: i18nEl ? i18nEl.dataset.wishlistEmpty : 'No items have been added to your wishlist.',
    wishlistAddToCart: i18nEl ? i18nEl.dataset.wishlistAddToCart : 'Add to cart',
    wishlistAddToCartLong: i18nEl ? i18nEl.dataset.wishlistAddToCartLong : 'Add to cart',
    wishlistViewDetail: i18nEl ? i18nEl.dataset.wishlistViewDetail : 'View details',
    wishlistSoldOut: i18nEl ? i18nEl.dataset.wishlistSoldOut : 'Sold out',
    wishlistModalTitle: i18nEl ? i18nEl.dataset.wishlistModalTitle : 'Add to wishlist',
    wishlistClose: i18nEl ? i18nEl.dataset.wishlistClose : 'Close',
    wishlistOutOfStock: i18nEl ? i18nEl.dataset.wishlistOutOfStock : '(Out of stock)',
    wishlistColorLabel: i18nEl ? i18nEl.dataset.wishlistColorLabel : 'Color:',
    wishlistSizeLabel: i18nEl ? i18nEl.dataset.wishlistSizeLabel : 'Size:',
    wishlistAddedToCart: i18nEl ? i18nEl.dataset.wishlistAddedToCart : 'Added',
    wishlistBackToTop: i18nEl ? i18nEl.dataset.wishlistBackToTop : 'Back to top',
    wishlistSavedToast: i18nEl ? i18nEl.dataset.wishlistSavedToast : 'Saved to wishlist',
    wishlistViewList: i18nEl ? i18nEl.dataset.wishlistViewList : 'View wishlist',
    wishlistFilterInStock: i18nEl ? i18nEl.dataset.wishlistFilterInStock : 'In stock',
    wishlistFilterSoldOut: i18nEl ? i18nEl.dataset.wishlistFilterSoldOut : 'Sold out'
  };
  var STORAGE_KEY = 'heart_wishlist_v3';
  var CUSTOMER_KEY = 'heart_wishlist_customer_v1';
  var COLOR_KEYS = ['color', 'colour', '色', 'カラー', 'couleur', 'farbe'];
  var SIZE_KEYS  = ['size', 'サイズ', 'taille', 'größe', 'talla'];

  /* ── Storage ─────────────────────────────────────────────────── */
  function load() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return new Map(saved);
    } catch (e) { return new Map(); }
  }
  function save() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([].concat(Array.from(window.heartWishlist))));
  }

  /* Post-login redirect to wishlist is handled by an inline script in theme.liquid <head> */
  var currentCustomerId = i18nEl ? i18nEl.dataset.customerId : null;

  /* ── Clear wishlist on logout / user switch (preserve anon → login sync) ── */
  var lastCustomerId = null;
  try { lastCustomerId = localStorage.getItem(CUSTOMER_KEY); } catch (e) {}
  /* Only clear when transitioning AWAY from a logged-in user:
     - logout (lastCustomerId → empty/null currentCustomerId)
     - user switch (lastCustomerId → different currentCustomerId)
     NOT when anonymous → logged-in (lastCustomerId empty, currentCustomerId set):
     in that case syncToServer() will push local items to the server. */
  if (lastCustomerId && String(lastCustomerId) !== String(currentCustomerId || '')) {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }
  /* Update stored customer ID to reflect current state */
  try {
    if (currentCustomerId) localStorage.setItem(CUSTOMER_KEY, String(currentCustomerId));
    else localStorage.removeItem(CUSTOMER_KEY);
  } catch (e) {}

  window.heartWishlist = load();
  window.heartWishlistKeys = new Set(window.heartWishlist.keys());

  /* ── Server sync (logged-in users) ──────────────────────────── */
  var customerId = currentCustomerId;
  var isSyncing = false;

  function toGid(type, id) {
    var s = String(id);
    if (s.indexOf('gid://') === 0) return s;
    return 'gid://shopify/' + type + '/' + s;
  }

  function fromGid(gid) {
    var parts = String(gid).split('/');
    return parts[parts.length - 1];
  }

  function getAPI() {
    return window.ecosaleWishlistAPI || null;
  }

  function syncToServer() {
    var api = getAPI();
    if (!customerId || !api || isSyncing) return;
    isSyncing = true;
    var items = [];
    window.heartWishlist.forEach(function (entry) {
      items.push({
        productId: toGid('Product', entry.productId),
        variantId: toGid('ProductVariant', entry.variantId),
        handle: entry.handle || '',
        title: entry.title || '',
        color: entry.color || '',
        size: entry.size || ''
      });
    });
    api.sync(items)
      .then(function () { return fetchFromServer(); })
      .then(function () {
        /* Re-render UI after server merge */
        initHeartButtons();
        refreshHeaderIcon();
        renderWishlistPage();
      })
      .catch(function () {})
      .finally(function () { isSyncing = false; });
  }

  function fetchFromServer() {
    var api = getAPI();
    if (!customerId || !api) return Promise.resolve();
    return api.get()
      .then(function (serverItems) {
        /* Defensive guard: if local has entries but server returned empty,
           treat as suspicious (server hiccup / eventual consistency) and skip
           the wipe. The next sync attempt will reconcile. */
        var localCount = window.heartWishlist.size;
        var serverCount = Array.isArray(serverItems) ? serverItems.length : 0;
        if (localCount > 0 && serverCount === 0) return;
        /* Server is source of truth — replace local data entirely */
        window.heartWishlist.clear();
        window.heartWishlistKeys.clear();
        serverItems.forEach(function (item) {
          var pid = fromGid(item.productId);
          var vid = fromGid(item.variantId);
          var key = variantKey(pid, vid);
          window.heartWishlist.set(key, {
            productId: pid,
            variantId: vid,
            handle: item.handle || '',
            title: item.title || '',
            color: item.color || '',
            size: item.size || ''
          });
          window.heartWishlistKeys.add(key);
        });
        save();
        initHeartButtons();
        initDetailWishlistBtns();
        injectRankingHearts();
        refreshHeaderIcon();
        renderWishlistPage();
      })
      .catch(function () {});
  }

  function serverAddVariant(entry) {
    var api = getAPI();
    if (!customerId || !api) return;
    api.sync([{
      productId: toGid('Product', entry.productId),
      variantId: toGid('ProductVariant', entry.variantId),
      handle: entry.handle || '',
      title: entry.title || '',
      color: entry.color || '',
      size: entry.size || ''
    }]).catch(function () {});
  }

  function serverDeleteVariant(variantId) {
    var api = getAPI();
    if (!customerId || !api) return;
    api.delete(toGid('ProductVariant', variantId))
      .catch(function () {});
  }

  /* ── Helpers ─────────────────────────────────────────────────── */
  function isProductLiked(productId, handle) {
    for (var entry of window.heartWishlist) {
      var e = entry[1];
      if (e.productId === productId) return true;
      /* Also match by handle — old entries may have handle stored as productId */
      if (handle && e.productId === handle) return true;
      if (handle && e.handle === handle) return true;
      if (productId && e.handle === productId) return true;
    }
    return false;
  }
  function isVariantLiked(productId, variantId) {
    if (!productId || !variantId) return false;
    return window.heartWishlist.has(variantKey(productId, variantId));
  }

  /* Migrate old entries that used handle as productId to numeric ID */
  function migrateHandleEntries() {
    var toMigrate = [];
    window.heartWishlist.forEach(function (entry, key) {
      /* If productId looks like a handle (contains letters, not purely numeric) */
      if (entry.productId && entry.handle && entry.productId === entry.handle) return;
      if (entry.productId && !/^\d+$/.test(entry.productId) && entry.handle) {
        toMigrate.push({ key: key, entry: entry });
      }
    });
    if (toMigrate.length === 0) return;
    var handles = {};
    toMigrate.forEach(function (item) {
      var h = item.entry.handle || item.entry.productId;
      if (h) handles[h] = handles[h] || [];
      if (h) handles[h].push(item);
    });
    Object.keys(handles).forEach(function (handle) {
      fetchProduct(handle)
        .then(function (product) {
          if (!product || !product.id) return;
          var numericId = String(product.id);
          handles[handle].forEach(function (item) {
            var oldKey = item.key;
            var entry = item.entry;
            window.heartWishlist.delete(oldKey);
            window.heartWishlistKeys.delete(oldKey);
            entry.productId = numericId;
            if (!entry.handle) entry.handle = handle;
            var newKey = variantKey(numericId, entry.variantId);
            window.heartWishlist.set(newKey, entry);
            window.heartWishlistKeys.add(newKey);
          });
          save();
          refreshAllCards(numericId);
          refreshHeaderIcon();
        })
        .catch(function () {});
    });
  }
  function variantKey(productId, variantId) {
    return productId + '_' + variantId;
  }

  /* ── Card button state ───────────────────────────────────────── */
  function refreshCardBtn(btn) {
    var pid = btn.dataset.productId;
    var handle = btn.dataset.productHandle || '';
    var color = btn.dataset.productColor || '';
    var icon = btn.querySelector('.heart-icon');
    /* If the card represents a specific color (collection page splits by color),
       fill heart only when a variant of THIS color is liked.
       Otherwise fall back to "any variant of this product liked". */
    var liked;
    if (color) {
      liked = false;
      for (var entry of window.heartWishlist) {
        var e = entry[1];
        var matchProduct = e.productId === pid || (handle && e.handle === handle);
        if (matchProduct && e.color === color) { liked = true; break; }
      }
    } else {
      liked = isProductLiked(pid, handle);
    }
    if (liked) {
      btn.classList.add('is-liked');
      btn.setAttribute('aria-pressed', 'true');
      if (icon) { icon.style.setProperty('fill', '#e53e3e', 'important'); icon.style.setProperty('stroke', '#e53e3e', 'important'); }
    } else {
      btn.classList.remove('is-liked');
      btn.setAttribute('aria-pressed', 'false');
      if (icon) { icon.style.setProperty('fill', 'none', 'important'); icon.style.setProperty('stroke', '#999', 'important'); }
    }
  }
  function refreshAllCards(productId) {
    document.querySelectorAll('.hwl-heart[data-product-id="' + productId + '"]')
      .forEach(refreshCardBtn);
  }

  /* ── Modal ───────────────────────────────────────────────────── */
  var modal = null;
  var currentProduct = null;
  var selectedColorValue = null;

  /* ── Template helpers ─────────────────────────────────────── */
  function cloneTemplate(id) {
    var tpl = document.getElementById(id);
    return tpl ? tpl.content.cloneNode(true) : null;
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.id = 'hwl-modal';
    modal.className = 'hwl-hidden';
    var frag = cloneTemplate('hwl-tpl-modal');
    if (frag) {
      modal.appendChild(frag);
    }
    document.body.appendChild(modal);
    modal.querySelector('.hwl-overlay').addEventListener('click', closeModal);
    modal.querySelector('.hwl-close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    /* Close on any click outside the dialog (anywhere on the page) */
    document.addEventListener('click', function (e) {
      if (!modal || modal.classList.contains('hwl-hidden')) return;
      var dialog = modal.querySelector('.hwl-dialog');
      if (dialog && !dialog.contains(e.target)) closeModal();
    }, true);
  }

  function openModal(btn) {
    if (!modal) buildModal();
    var handle = btn.dataset.productHandle;
    var pid = btn.dataset.productId;
    /* Pre-select the card's color so the modal opens on that color section
       (instead of defaulting to the first option value). */
    selectedColorValue = btn.dataset.productColor || null;

    var body = modal.querySelector('.hwl-body');

    /* The product image is already on screen and decoded by the browser — reuse
       it as the modal's initial hero so the popup shows an image instantly
       (critical on mobile tap, where there's no hover to prefetch). renderModal
       then swaps in the _400x version seamlessly. */
    var cardImgEl = getCardImgEl(btn);
    var cardImgSrc = cardImgEl ? (cardImgEl.currentSrc || cardImgEl.src || '') : '';

    /* Render the modal body from an already-normalized product object (cached or
       freshly fetched). Content + hero image appear together because the hero is
       seeded from the card's already-loaded image, then revealed immediately —
       no waiting on a network image download. */
    function showProduct(data) {
      currentProduct = data;
      currentProduct._pid = String(pid);
      currentProduct._handle = handle;

      body.innerHTML =
        '<div class="hwl-left">' +
          '<img class="hwl-product-img" src="' + (cardImgSrc || '') + '" alt="">' +
          '<p class="hwl-color-label"></p>' +
          '<div class="hwl-swatches"></div>' +
        '</div>' +
        '<div class="hwl-right">' +
          '<ul class="hwl-variant-list"></ul>' +
        '</div>';
      renderModal(currentProduct);
    }

    /* Always show skeleton first; fetchProduct resolves instantly on a cache hit
       (embedded JSON / prior fetch) and dedupes any in-flight request. */
    body.innerHTML = '';
    var skFrag = cloneTemplate('hwl-tpl-modal-skeleton');
    if (skFrag) body.appendChild(skFrag);
    modal.classList.remove('hwl-hidden');
    document.body.style.overflow = 'hidden';

    fetchProduct(handle)
      .then(function (data) { showProduct(data); })
      .catch(function () { closeModal(); });
  }

  function closeModal() {
    if (!modal) return;
    /* Check if product was liked before clearing state */
    var savedProduct = currentProduct;
    modal.classList.add('hwl-hidden');
    document.body.style.overflow = '';
    currentProduct = null;
    selectedColorValue = null;

    /* Show confirmation toast if product has liked variants */
    if (savedProduct && isProductLiked(savedProduct._pid, savedProduct._handle)) {
      showWishlistToast(savedProduct);
    }
  }

  /* ── Wishlist confirmation toast ─────────────────────────────── */
  var toastEl = null;
  var toastTimer = null;

  function buildToast() {
    toastEl = document.createElement('div');
    toastEl.id = 'hwl-toast';
    toastEl.className = 'hwl-toast hwl-toast--hidden';
    var frag = cloneTemplate('hwl-tpl-toast');
    if (frag) toastEl.appendChild(frag);
    document.body.appendChild(toastEl);
    toastEl.querySelector('.hwl-toast-overlay').addEventListener('click', closeToast);
    toastEl.querySelector('.hwl-toast-close').addEventListener('click', closeToast);
    /* Close on any click outside the dialog (anywhere on the page) */
    document.addEventListener('click', function (e) {
      if (!toastEl || toastEl.classList.contains('hwl-toast--hidden')) return;
      var dialog = toastEl.querySelector('.hwl-toast-dialog');
      if (dialog && !dialog.contains(e.target)) closeToast();
    }, true);
  }

  function closeToast() {
    if (!toastEl) return;
    toastEl.classList.add('hwl-toast--hidden');
    if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }
  }

  function showWishlistToast(product) {
    if (!toastEl) buildToast();

    /* Gather liked variants for this product */
    var likedVariants = [];
    window.heartWishlist.forEach(function (entry) {
      if (entry.productId === product._pid) {
        likedVariants.push(entry);
      }
    });
    if (likedVariants.length === 0) return;

    /* Group liked variants by color */
    var colorGroups = {};
    likedVariants.forEach(function (v) {
      var c = v.color || '';
      if (!colorGroups[c]) colorGroups[c] = [];
      if (v.size && colorGroups[c].indexOf(v.size) === -1) colorGroups[c].push(v.size);
    });

    /* Image: use the most-recently-liked variant's image (Map iteration is
       insertion order, so likedVariants[last] is the latest add).
       For exactly 1 liked variant, that's the same as "its own image". */
    var defaultImg = '';
    var lastLiked = likedVariants[likedVariants.length - 1];
    if (lastLiked && product.variants) {
      var matchedVariant = product.variants.find(function (pv) {
        return String(pv.id) === String(lastLiked.variantId);
      });
      var variantImgSrc = getVariantImageSrc(product, matchedVariant);
      if (variantImgSrc) defaultImg = variantImgSrc;
    }
    if (!defaultImg && product.images && product.images.length > 0) {
      var firstImg = product.images[0];
      defaultImg = firstImg.src || firstImg || '';
    }
    if (defaultImg) {
      defaultImg = defaultImg.replace(/\.(jpg|jpeg|png|webp)/, '_200x.$1');
    }

    /* Condition tag: detect the 商品状態 option by name (its position can be 2
       or 3 depending on whether the product has a Size option). Use the
       matched variant's value for that position. If the product has multiple
       条件 values across its variants (rental + new mixed), default to rental. */
    var conditionTag = '';
    var conditionOption = product.options && product.options.find(function (o) {
      var n = (typeof o === 'string' ? o : (o.name || '')).toLowerCase();
      return n === '商品状態' || n === '商品状态' || n === 'condition' || n === '状態';
    });
    var conditionPos = null;
    if (conditionOption) {
      conditionPos = typeof conditionOption === 'string'
        ? (product.options.indexOf(conditionOption) + 1)
        : conditionOption.position;
    }
    var optionConditionSet = {};
    if (conditionPos && product.variants) {
      product.variants.forEach(function (v) {
        var val = v['option' + conditionPos];
        if (val) optionConditionSet[val] = true;
      });
    }
    var conditionVal = '';
    if (Object.keys(optionConditionSet).length > 1) {
      conditionVal = 'レンタル品';
    } else if (matchedVariant && conditionPos) {
      conditionVal = matchedVariant['option' + conditionPos] || '';
    }
    if (conditionVal === 'レンタル品') {
      conditionTag = '<span class="hwl-toast-tag hwl-toast-tag--rental">レンタル品</span>';
    } else if (conditionVal === '新品') {
      conditionTag = '<span class="hwl-toast-tag hwl-toast-tag--new">新品</span>';
    }

    /* Build body — single product card, one variant row per color */
    var bodyHtml = '<div class="hwl-toast-product">';
    bodyHtml += '<img class="hwl-toast-img" src="' + defaultImg + '" alt="">';
    bodyHtml += '<div class="hwl-toast-info">';
    bodyHtml += '<div class="hwl-toast-info-top">';
    bodyHtml += '<span class="hwl-toast-vendor">' + (product.vendor || '') + '</span>';
    bodyHtml += conditionTag;
    bodyHtml += '</div>';
    bodyHtml += '<p class="hwl-toast-product-title">' + (product.title || '') + '</p>';
    /* Detect whether the product actually has Color / Size options.
       Only show those parts in the toast if the option truly exists. */
    var hasColorOption = !!(product.options && product.options.find(function (o) {
      var n = (typeof o === 'string' ? o : (o.name || '')).toLowerCase();
      return COLOR_KEYS.indexOf(n) !== -1;
    }));
    var hasSizeOption = !!(product.options && product.options.find(function (o) {
      var n = (typeof o === 'string' ? o : (o.name || '')).toLowerCase();
      return SIZE_KEYS.indexOf(n) !== -1;
    }));

    var colorKeys = Object.keys(colorGroups);
    colorKeys.forEach(function (colorVal) {
      var showColor = hasColorOption && colorVal;
      /* Drop sizes that equal the color (legacy data). Only consider sizes
         if the product actually has a Size option. */
      var sizes = hasSizeOption
        ? (colorGroups[colorVal] || []).filter(function (sz) { return sz && sz !== colorVal; })
        : [];
      /* Nothing to display → skip the row */
      if (!showColor && sizes.length === 0) return;
      if (sizes.length === 0) {
        bodyHtml += '<div class="hwl-toast-variant">';
        bodyHtml += '<span class="hwl-toast-color">' + colorVal + '</span>';
        bodyHtml += '</div>';
      } else {
        sizes.forEach(function (sz) {
          bodyHtml += '<div class="hwl-toast-variant">';
          bodyHtml += '<span class="hwl-toast-size">' + i18n.wishlistSizeLabel + ' ' + sz + '</span>';
          if (showColor) bodyHtml += '<span class="hwl-toast-color">' + colorVal + '</span>';
          bodyHtml += '</div>';
        });
      }
    });
    bodyHtml += '</div></div>';

    toastEl.querySelector('.hwl-toast-body').innerHTML = bodyHtml;
    toastEl.classList.remove('hwl-toast--hidden');

    /* Auto-hide after 5 seconds */
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(closeToast, 5000);
  }

  function renderModal(product) {
    var colorOption = product.options.find(function (o) { return COLOR_KEYS.indexOf(o.name.toLowerCase()) !== -1; });
    var sizeOption = product.options.find(function (o) { return SIZE_KEYS.indexOf(o.name.toLowerCase()) !== -1; });
    var colorPos = colorOption ? colorOption.position : null;
    var sizePos = sizeOption ? sizeOption.position : null;

    if (colorOption) {
      /* If a pre-selected color (from card) doesn't actually match any value, ignore it */
      if (selectedColorValue && colorOption.values.indexOf(selectedColorValue) === -1) {
        selectedColorValue = null;
      }
      if (!selectedColorValue) {
        selectedColorValue = colorOption.values[0];
      }
    }

    var imgEl = modal.querySelector('.hwl-product-img');
    /* Use selected variant's image if available; fall back to product's first image */
    var imgSrc = '';
    if (colorPos && selectedColorValue) {
      var selectedVariant = product.variants.find(function (v) { return getOptionVal(v, colorPos) === selectedColorValue; });
      imgSrc = getVariantImageSrc(product, selectedVariant) || '';
    }
    if (!imgSrc) {
      var firstImg = product.images[0];
      imgSrc = firstImg ? (firstImg.src || firstImg) : '';
    }
    setHeroImage(imgEl, imgSrc ? imgSrc.replace(/\.(jpg|jpeg|png|webp)/, '_400x.$1') : '');
    imgEl.alt = product.title;

    var colorLabelEl = modal.querySelector('.hwl-color-label');
    if (colorOption) {
      colorLabelEl.textContent = colorOption.name + ': ' + (selectedColorValue || '');
      colorLabelEl.style.display = 'block';
    } else {
      colorLabelEl.style.display = 'none';
    }
    var swatchesEl = modal.querySelector('.hwl-swatches');
    swatchesEl.innerHTML = '';
    if (colorOption) {
      colorOption.values.forEach(function (val) {
        var variant = product.variants.find(function (v) { return getOptionVal(v, colorPos) === val; });
        var sw = document.createElement('button');
        sw.className = 'hwl-swatch' + (val === selectedColorValue ? ' is-active' : '');
        sw.title = val;
        sw.type = 'button';
        /* Trust hex from color name first. Only extract from variant image
           when the name didn't match (returns default #cccccc). */
        var hex = colorNameToHex(val);
        sw.style.backgroundColor = hex;
        if (hex === '#cccccc') {
          var swatchImg = getVariantImageSrc(product, variant);
          if (swatchImg) {
            extractDominantColor(swatchImg.replace(/\.(jpg|jpeg|png|webp)/, '_72x.$1'), function (color) {
              if (color) sw.style.backgroundColor = color;
            });
          }
        }
        sw.addEventListener('click', function () {
          selectedColorValue = val;
          var newImgSrc = getVariantImageSrc(product, variant);
          if (newImgSrc) {
            setHeroImage(imgEl, newImgSrc.replace(/\.(jpg|jpeg|png|webp)/, '_400x.$1'));
          }
          renderModal(product);
        });
        swatchesEl.appendChild(sw);
      });
    }

    var listEl = modal.querySelector('.hwl-variant-list');
    listEl.innerHTML = '';
    var variants = colorPos
      ? product.variants.filter(function (v) { return getOptionVal(v, colorPos) === selectedColorValue; })
      : product.variants;

    variants.forEach(function (variant) {
      var colorVal = colorPos ? getOptionVal(variant, colorPos) : '';
      var sizeVal = sizePos ? getOptionVal(variant, sizePos) : variant.title;
      var available = variant.available;
      var key = variantKey(product._pid, String(variant.id));
      var liked = window.heartWishlist.has(key);

      var liFrag = cloneTemplate('hwl-tpl-variant-row');
      var li = liFrag ? liFrag.querySelector('li') : document.createElement('li');
      if (!available) li.classList.add('hwl-variant-row--unavailable');
      var nameEl = li.querySelector('.hwl-variant-name');
      nameEl.textContent = sizeVal;
      if (!available) {
        var unavail = document.createElement('span');
        unavail.className = 'hwl-unavail';
        unavail.textContent = i18n.wishlistOutOfStock;
        nameEl.appendChild(unavail);
      }
      var heartBtn = li.querySelector('.hwl-variant-heart');
      heartBtn.dataset.key = key;
      heartBtn.dataset.productId = product._pid;
      heartBtn.setAttribute('aria-pressed', String(liked));
      heartBtn.setAttribute('aria-label', sizeVal + ' ' + i18n.addToWishlist);
      if (liked) heartBtn.classList.add('is-liked');

      li.querySelector('.hwl-variant-heart').addEventListener('click', function () {
        toggleVariant(key, product._pid, variant.id, colorVal, sizeVal, product.title, product._handle);
        var heartBtn = li.querySelector('.hwl-variant-heart');
        heartBtn.classList.toggle('is-liked');
        heartBtn.setAttribute('aria-pressed', String(heartBtn.classList.contains('is-liked')));
      });
      listEl.appendChild(li);
    });
  }

  function getOptionVal(variant, position) {
    return variant['option' + position];
  }

  /* Resolve a variant's image src across the various Shopify response formats */
  /* Extract dominant color by quantizing pixels and picking the bucket with the most votes.
     Samples only the center 60% of the image to avoid background bleed.
     Uses 6-bit quantization (each channel 0-63) for a stable mode. */
  var dominantColorCache = {};
  function extractDominantColor(imgUrl, callback) {
    if (!imgUrl) { callback(null); return; }
    if (dominantColorCache[imgUrl] !== undefined) { callback(dominantColorCache[imgUrl]); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var canvas = document.createElement('canvas');
        var size = 64;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, size, size);
        /* Sample only center 60% — avoids photo background */
        var pad = Math.floor(size * 0.2);
        var data = ctx.getImageData(pad, pad, size - pad*2, size - pad*2).data;
        var buckets = {};
        var bestKey = null, bestCount = 0;
        for (var i = 0; i < data.length; i += 4) {
          var a = data[i+3];
          if (a < 128) continue;
          var pr = data[i], pg = data[i+1], pb = data[i+2];
          /* Skip extreme white AND extreme black (likely background/shadow) */
          if (pr > 240 && pg > 240 && pb > 240) continue;
          if (pr < 15 && pg < 15 && pb < 15) continue;
          /* Quantize to 4-bit per channel (16 levels) for stable buckets */
          var qr = pr >> 4, qg = pg >> 4, qb = pb >> 4;
          var key = qr * 256 + qg * 16 + qb;
          buckets[key] = (buckets[key] || 0) + 1;
          if (buckets[key] > bestCount) { bestCount = buckets[key]; bestKey = key; }
        }
        if (bestKey === null) { dominantColorCache[imgUrl] = null; callback(null); return; }
        /* Convert back to RGB — use center of bucket */
        var br = ((bestKey >> 8) & 15) * 16 + 8;
        var bg = ((bestKey >> 4) & 15) * 16 + 8;
        var bb = (bestKey & 15) * 16 + 8;
        var color = 'rgb(' + br + ',' + bg + ',' + bb + ')';
        dominantColorCache[imgUrl] = color;
        callback(color);
      } catch (e) {
        console.warn('[HWL] dominant color extraction failed (likely CORS):', e.message);
        dominantColorCache[imgUrl] = null;
        callback(null);
      }
    };
    img.onerror = function () { dominantColorCache[imgUrl] = null; callback(null); };
    img.src = imgUrl;
  }

  function getVariantImageSrc(product, variant) {
    if (!variant) return null;
    var fi = variant.featured_image;
    if (fi) {
      if (typeof fi === 'string') return fi;
      if (fi.src) return fi.src;
      /* fi is an integer ID — find matching image in product.images */
      if (typeof fi === 'number' && product.images) {
        for (var i = 0; i < product.images.length; i++) {
          var img = product.images[i];
          if (img && (img.id === fi || img.position === fi)) {
            return img.src || img;
          }
        }
      }
    }
    if (variant.featured_media) {
      var fm = variant.featured_media;
      if (fm.preview_image && fm.preview_image.src) return fm.preview_image.src;
      if (fm.src) return fm.src;
    }
    return null;
  }

  /* ── Wishlist CRUD ───────────────────────────────────────────── */
  function toggleVariant(key, productId, variantId, color, size, title, handle) {
    var wasLiked = window.heartWishlist.has(key);
    if (wasLiked) {
      window.heartWishlist.delete(key);
      window.heartWishlistKeys.delete(key);
    } else {
      var entry = {
        productId: productId,
        variantId: String(variantId),
        color: color || '',
        size: size || '',
        title: title || '',
        handle: handle || ''
      };
      window.heartWishlist.set(key, entry);
      window.heartWishlistKeys.add(key);
      serverAddVariant(entry);
    }
    save();
    refreshAllCards(productId);
    refreshHeaderIcon();
    if (wasLiked) serverDeleteVariant(variantId);
    document.dispatchEvent(new CustomEvent('heart:change', {
      detail: { key: key, liked: !wasLiked, productId: productId, variantId: variantId, color: color, size: size, title: title }
    }));
  }

  function colorNameToHex(name) {
    /* Exact match map */
    var map = {
      'white':'#ffffff','ホワイト':'#ffffff','白':'#ffffff','オフホワイト':'#faf9f6','off white':'#faf9f6',
      'black':'#1a1a1a','ブラック':'#1a1a1a','黒':'#1a1a1a',
      'gray':'#9e9e9e','grey':'#9e9e9e','グレー':'#9e9e9e','グレイ':'#9e9e9e','灰':'#9e9e9e',
      'lightgray':'#cbd5e0','light gray':'#cbd5e0','ライトグレー':'#cbd5e0',
      'darkgray':'#4a5568','dark gray':'#4a5568','ダークグレー':'#4a5568','チャコール':'#36454f','charcoal':'#36454f',
      'navy':'#1a2a4a','ネイビー':'#1a2a4a','紺':'#1a2a4a',
      'beige':'#d4b896','ベージュ':'#d4b896','グレージュ':'#a89b8c','greige':'#a89b8c',
      'pink':'#f4a7b9','ピンク':'#f4a7b9','桃':'#f4a7b9',
      'lightpink':'#ffd1dc','light pink':'#ffd1dc','ライトピンク':'#ffd1dc',
      'red':'#e53e3e','レッド':'#e53e3e','赤':'#e53e3e','ワインレッド':'#722f37','wine':'#722f37','バーガンディ':'#722f37','burgundy':'#722f37','ボルドー':'#722f37','bordeaux':'#722f37',
      'blue':'#4a90d9','ブルー':'#4a90d9','青':'#4a90d9',
      'lightblue':'#add8e6','light blue':'#add8e6','ライトブルー':'#add8e6','サックス':'#9bb7d4','sax':'#9bb7d4','サックスブルー':'#9bb7d4','アイスブルー':'#a9c7d8',
      'darkblue':'#1a3a6a','dark blue':'#1a3a6a','ダークブルー':'#1a3a6a',
      'green':'#48bb78','グリーン':'#48bb78','緑':'#48bb78','カーキ':'#8a8b56','khaki':'#8a8b56','オリーブ':'#6b6e2c','olive':'#6b6e2c','モスグリーン':'#5b6f37','moss':'#5b6f37','フォレスト':'#228b22','ミント':'#aaf0d1','mint':'#aaf0d1','ミントグリーン':'#aaf0d1',
      'brown':'#8b6343','ブラウン':'#8b6343','茶':'#8b6343','ダークブラウン':'#3d2b1f','dark brown':'#3d2b1f','チョコレート':'#3d2b1f','chocolate':'#3d2b1f','モカ':'#7e5e44','mocha':'#7e5e44','テラコッタ':'#cc6f4f','terracotta':'#cc6f4f',
      'camel':'#c19a6b','キャメル':'#c19a6b','タン':'#d2a679','tan':'#d2a679',
      'ivory':'#fffff0','アイボリー':'#fffff0','エクリュ':'#f0ead6','ecru':'#f0ead6','ナチュラル':'#f0ead6','natural':'#f0ead6',
      'yellow':'#f6e05e','イエロー':'#f6e05e','黄':'#f6e05e','マスタード':'#c9a227','mustard':'#c9a227','レモン':'#fff44f','lemon':'#fff44f',
      'orange':'#ed8936','オレンジ':'#ed8936','コーラル':'#ff7f50','coral':'#ff7f50','サーモン':'#fa8072','salmon':'#fa8072',
      'purple':'#805ad5','パープル':'#805ad5','紫':'#805ad5','ラベンダー':'#b794f4','lavender':'#b794f4','モーブ':'#b288a4','mauve':'#b288a4',
      'gold':'#d4af37','ゴールド':'#d4af37','金':'#d4af37',
      'silver':'#c0c0c0','シルバー':'#c0c0c0','銀':'#c0c0c0'
    };
    var raw = (name || '').trim();
    var lower = raw.toLowerCase();
    if (map[raw]) return map[raw];
    if (map[lower]) return map[lower];
    /* Smart match: find any keyword from the map inside the color name
       (e.g. "ライトベージュ" → match "ベージュ", "ダスティピンク" → "ピンク") */
    for (var key in map) {
      if (key.length >= 2 && (raw.indexOf(key) !== -1 || lower.indexOf(key) !== -1)) {
        return map[key];
      }
    }
    return '#cccccc';
  }

  /* ── Product detail page wishlist button ─────────────────────── */
  function refreshDetailBtn(btn) {
    var pid = btn.dataset.productId;
    var handle = btn.dataset.productHandle || '';
    var label = btn.querySelector('.product-detail__wishlist-label');
    /* Show "saved" if ANY variant of this product is liked — the favorited
       variant (e.g. Blue/M) may differ from the page's selected variant (Blue/S). */
    var liked = isProductLiked(pid, handle);
    if (liked) {
      btn.classList.add('is-liked');
      btn.setAttribute('aria-pressed', 'true');
      if (label) label.textContent = label.dataset.savedText || i18n.savedToWishlist;
    } else {
      btn.classList.remove('is-liked');
      btn.setAttribute('aria-pressed', 'false');
      if (label) label.textContent = label.dataset.addText || i18n.addToWishlist;
    }
  }
  function refreshAllDetailBtns(productId) {
    document.querySelectorAll('.product-detail__wishlist-btn[data-product-id="' + productId + '"]')
      .forEach(refreshDetailBtn);
  }
  function initDetailWishlistBtns() {
    document.querySelectorAll('.product-detail__wishlist-btn').forEach(function (btn) {
      if (btn.dataset.heartInit) return;
      btn.dataset.heartInit = '1';
      refreshDetailBtn(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        /* Always open modal — same as card hearts. User toggles individual
           sizes/colors inside the popup (add or remove). */
        openModal(btn);
      });
    });
  }
  document.addEventListener('heart:change', function (e) {
    var productId = e.detail.productId;
    if (productId) refreshAllDetailBtns(productId);
  });
  /* Sync PDP heart with currently-selected variant */
  document.addEventListener('variant:changed', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || !variant.id) return;
    document.querySelectorAll('.product-detail__wishlist-btn').forEach(function (btn) {
      btn.dataset.productVariantId = String(variant.id);
      refreshDetailBtn(btn);
    });
  });

  /* WH app targets <button> elements — we use <div> to avoid detection */

  /* ── Create heart button element ─────────────────────────────── */
  function createHeartBtn(productId, handle, title, variantId, color) {
    /* Use <div> instead of <button> — WH app only targets <button> elements */
    var btn = document.createElement('div');
    btn.setAttribute('role', 'button');
    btn.setAttribute('tabindex', '0');
    btn.className = 'hwl-heart';
    btn.setAttribute('aria-label', i18n.addToWishlist);
    btn.dataset.productId = String(productId);
    btn.dataset.productHandle = handle || '';
    btn.dataset.productTitle = title || '';
    btn.dataset.productVariantId = variantId ? String(variantId) : '';
    btn.dataset.productColor = color || '';
    btn.dataset.hwlInline = '1';
    var svgFrag = cloneTemplate('hwl-tpl-heart-svg');
    if (svgFrag) {
      var svg = svgFrag.querySelector('svg');
      svg.setAttribute('width', '18');
      svg.setAttribute('height', '16');
      btn.appendChild(svgFrag);
    }
    btn.style.cssText = 'position:absolute;bottom:0.8rem;right:0.8rem;z-index:2;display:flex;align-items:center;justify-content:center;width:40px;height:40px;background:rgba(255,255,255,0.88);border:none;border-radius:50%;padding:0;margin:0;cursor:pointer;box-shadow:none;line-height:normal;font-size:0;color:transparent;transition:background 0.2s,transform 0.2s;overflow:visible;';
    var icon = btn.querySelector('.heart-icon');
    icon.style.cssText = 'fill:none;stroke:#999;stroke-width:2;transition:fill 0.2s,stroke 0.2s;';
    refreshCardBtn(btn);
    /* Warm the cache on hover/touch so the modal opens instantly on click.
       fetchProduct dedupes, so this never causes a duplicate request. */
    function prefetchProduct() {
      var productHandle = btn.dataset.productHandle;
      if (!productHandle) return;
      var color = btn.dataset.productColor || null;
      /* Warm both the product data and its hero image so the popup opens with
         image + text together, no late image pop-in. */
      fetchProduct(productHandle)
        .then(function (product) { if (product) preloadImage(heroImageSrc(product, color)); })
        .catch(function () {});
    }
    btn.addEventListener('mouseenter', function () {
      btn.style.transform = 'scale(1.1)';
      btn.style.background = 'rgba(255,255,255,0.8)';
      var ic = btn.querySelector('.heart-icon');
      if (ic && !btn.classList.contains('is-liked')) {
        ic.style.stroke = '#e53e3e';
      }
      prefetchProduct();
    });
    btn.addEventListener('touchstart', prefetchProduct, { passive: true });
    btn.addEventListener('mouseleave', function () {
      btn.style.transform = btn.classList.contains('is-liked') ? 'scale(1)' : '';
      var ic = btn.querySelector('.heart-icon');
      if (ic && !btn.classList.contains('is-liked')) {
        ic.style.stroke = '#999';
      }
    });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      /* Always open modal — whether the user wants to ADD a variant or REMOVE
         already-liked ones, the modal lets them toggle individual sizes. */
      openModal(btn);
    });
    return btn;
  }

  /* ── Inject hearts into product cards ────────────────────────── */
  function initHeartButtons() {
    var cards = document.querySelectorAll('.product-card[data-product-id]');
    cards.forEach(function (card) {
      var imgWrapper = card.querySelector('.product-card__image-wrapper');
      if (!imgWrapper) return;
      /* Remove any old/stale heart buttons (e.g. from cached CDN script) and recreate */
      /* Remove old <button> hearts (from cached CDN script / WH) */
      imgWrapper.querySelectorAll('.product-card__heart-btn').forEach(function (old) { old.remove(); });
      /* Skip if we already injected */
      if (imgWrapper.querySelector('.hwl-heart')) return;
      /* Force overflow visible so button is not clipped */
      imgWrapper.style.setProperty('overflow', 'visible', 'important');
      var pid = card.dataset.productId;
      var handle = card.dataset.productHandle || '';
      var title = card.dataset.productTitle || '';
      var vid = card.dataset.productVariantId || '';
      var color = card.dataset.productColor || '';
      var btn = createHeartBtn(pid, handle, title, vid, color);
      btn.dataset.hwlInline = '1'; /* mark as ours */
      imgWrapper.appendChild(btn);
    });
  }

  /* ── Ranking app heart injection ─────────────────────────────── */
  function injectRankingHearts() {
    document.querySelectorAll(
      'shopify-section[id*="shopify-section"] a[href*="/products/"], ' +
      '.shopify-app-block a[href*="/products/"]'
    ).forEach(function (link) {
      if (link.closest('.product-card')) return;
      if (link.closest('[data-ranking-heart-init]')) return;
      var imgEl = link.querySelector('img');
      if (!imgEl) return;
      var match = link.href.match(/\/products\/([^?#/]+)/);
      if (!match) return;
      var handle = match[1];
      var imgWrapper = imgEl.parentElement;
      if (!imgWrapper || imgWrapper.dataset.rankingHeartInit) return;
      imgWrapper.dataset.rankingHeartInit = '1';
      var title = imgEl.alt || link.getAttribute('aria-label') || handle;
      var productId = link.dataset.productId
        || (link.closest('[data-product-id]') ? link.closest('[data-product-id]').dataset.productId : null);

      /* Fetch product to learn first-available variant's color, so the heart
         only fills when wishlist matches THIS card's displayed color. */
      (function (imgWrapper, handle, title, productId) {
        function inject(pid, vid, color) {
          var overlay = document.createElement('div');
          overlay.className = 'hwl-img-overlay';
          overlay.style.cssText = 'position:relative;display:block;line-height:0;';
          imgWrapper.parentNode.insertBefore(overlay, imgWrapper);
          overlay.appendChild(imgWrapper);
          var btn = createHeartBtn(pid, handle, title, vid || '', color || '');
          overlay.appendChild(btn);
        }
        function useProduct(product) {
          if (!product || !product.id) {
            inject(productId || handle, '', '');
            return;
          }
          var pid = String(product.id);
          var firstAvail = (product.variants || []).find(function (v) { return v.available; }) || product.variants[0];
          var vid = firstAvail ? String(firstAvail.id) : '';
          var color = '';
          if (firstAvail && product.options) {
            for (var i = 0; i < product.options.length; i++) {
              var optName = (typeof product.options[i] === 'string' ? product.options[i] : product.options[i].name || '').toLowerCase();
              if (COLOR_KEYS.indexOf(optName) !== -1) {
                color = firstAvail['option' + (i + 1)] || '';
                break;
              }
            }
          }
          inject(pid, vid, color);
        }
        /* Shared fetch: reuses cache / in-flight request, caches the result */
        fetchProduct(handle)
          .then(function (product) { useProduct(product); })
          .catch(function () { inject(productId || handle, '', ''); });
      })(imgWrapper, handle, title, productId);
    });
  }

  /* ── Header wishlist icon ────────────────────────────────────── */
  function refreshHeaderIcon() {
    var existing = document.querySelector('.hwl-header-link');

    if (!existing) {
      /* Find header icons area and inject */
      var headerIcons = document.querySelector('.header__icons--right .header__buttons');
      if (!headerIcons) return;

      var linkFrag = cloneTemplate('hwl-tpl-header-link');
      var link = linkFrag ? linkFrag.querySelector('a') : document.createElement('a');

      /* Insert before cart icon */
      var cartBtn = headerIcons.querySelector('.cart-drawer-button, .cart-icon');
      if (cartBtn) {
        headerIcons.insertBefore(link, cartBtn);
      } else {
        headerIcons.appendChild(link);
      }
      existing = link;
    }

    /* No badge — header heart always looks the same regardless of wishlist count */
    var badge = existing.querySelector('.hwl-header-badge');
    if (badge) {
      badge.style.display = 'none';
    }
  }

  /* ── Wishlist page rendering ─────────────────────────────────── */
  var currentSort = 'recommend';
  var currentView = 'grid';
  var fetchedProductCache = {};
  var inflightProductFetches = {}; /* handle -> in-flight Promise, to dedupe concurrent fetches */

  /* Normalize a product object so downstream code can assume a single shape:
     /products/.js returns images as URL strings, while .json / embedded JSON
     return {src} objects. Idempotent — safe to call more than once. */
  function normalizeProduct(product) {
    if (product && product.images && product.images.length && typeof product.images[0] === 'string') {
      product.images = product.images.map(function (url) { return { src: url }; });
    }
    return product;
  }

  /* Find the product image already rendered on screen for this button so the
     modal hero can be seeded from it instantly. On a card it's the thumbnail
     next to the heart; on the product detail page the heart sits in the
     buy-buttons form, so use the media gallery's active slide instead. */
  function getCardImgEl(btn) {
    if (btn.classList.contains('product-detail__wishlist-btn')) {
      return document.querySelector('.product__media-gallery-viewer .swiper-slide-active img')
        || document.querySelector('.product__media-gallery-viewer img');
    }
    return (btn.parentElement && btn.parentElement.querySelector('img'))
      || (btn.closest('.product-card') && btn.closest('.product-card').querySelector('img'));
  }

  /* Single entry point for fetching a product's .js — shared by ranking-heart
     injection, hover prefetch, the wishlist modal, and the wishlist page.
     Returns a Promise<product>. Resolved products are cached (keyed by handle
     and id); an in-flight request is reused so the same product is never
     fetched twice concurrently across any page. */
  function fetchProduct(handle) {
    if (!handle) return Promise.reject(new Error('no handle'));
    var cached = fetchedProductCache[handle];
    if (cached) return Promise.resolve(cached);
    if (inflightProductFetches[handle]) return inflightProductFetches[handle];
    var request = fetch('/products/' + handle + '.js')
      .then(function (response) { return response.json(); })
      .then(function (product) {
        normalizeProduct(product);
        if (product && product.id) {
          fetchedProductCache[handle] = product;
          fetchedProductCache[String(product.id)] = product;
        }
        delete inflightProductFetches[handle];
        return product;
      })
      .catch(function (err) {
        delete inflightProductFetches[handle];
        throw err;
      });
    inflightProductFetches[handle] = request;
    return request;
  }

  /* Read product JSON embedded in the page by Liquid (snippets/ecom_wishlist_product_json)
     into the cache, so the popup opens with zero API calls for theme-rendered
     cards. Safe to call repeatedly — each <script> is parsed once. */
  function indexEmbeddedProducts() {
    document.querySelectorAll('script.hwl-product-json').forEach(function (script) {
      if (script.dataset.hwlIndexed) return;
      script.dataset.hwlIndexed = '1';
      try {
        var product = normalizeProduct(JSON.parse(script.textContent));
        if (product && product.id) {
          if (product.handle) fetchedProductCache[product.handle] = product;
          fetchedProductCache[String(product.id)] = product;
        }
      } catch (err) { /* malformed JSON → fall back to API on demand */ }
    });
  }

  /* Warm the browser cache for an image URL so it paints instantly later. */
  function preloadImage(src) {
    if (!src) return;
    var img = new Image();
    img.src = src;
  }

  /* Swap a hero <img> to a new src without a blank flash: if the element
     already shows something, preload the new src and only swap once ready, so
     the current image stays visible meanwhile. */
  function setHeroImage(imgEl, src) {
    if (!imgEl || !src) return;
    if (imgEl.getAttribute('src') === src) return;
    if (!imgEl.getAttribute('src')) { imgEl.src = src; return; }
    var preloader = new Image();
    preloader.onload = function () { imgEl.src = src; };
    preloader.src = src;
  }

  /* The hero image the modal will show for a given product + card color —
     mirrors renderModal's image pick so we can preload it before opening. */
  function heroImageSrc(product, color) {
    if (!product || !product.options) return '';
    var colorOption = product.options.find(function (option) {
      return COLOR_KEYS.indexOf((option.name || '').toLowerCase()) !== -1;
    });
    var colorPos = colorOption ? colorOption.position : null;
    var selectedColor = color;
    if (colorOption) {
      if (selectedColor && colorOption.values.indexOf(selectedColor) === -1) selectedColor = null;
      if (!selectedColor) selectedColor = colorOption.values[0];
    }
    var imageSrc = '';
    if (colorPos && selectedColor) {
      var selectedProductVariant = (product.variants || []).find(function (variant) {
        return getOptionVal(variant, colorPos) === selectedColor;
      });
      imageSrc = getVariantImageSrc(product, selectedProductVariant) || '';
    }
    if (!imageSrc) {
      var firstProductImage = product.images && product.images[0];
      if (firstProductImage) {
        /* images entries can be a URL string (.js) or a {src} object (.json) */
        imageSrc = typeof firstProductImage === 'string' ? firstProductImage : (firstProductImage.src || '');
      }
    }
    return imageSrc ? imageSrc.replace(/\.(jpg|jpeg|png|webp)/, '_400x.$1') : '';
  }

  var activeFilters = { colors: [], sizes: [], priceMin: null, priceMax: null, inStock: false, soldOut: false };
  var filterDrawerEl = null;
  var allWishlistItems = []; /* cached for re-filtering */
  var filterMaxPrice = 0; /* max price across wishlist products */

  /* ── Filter drawer ───────────────────────────────────────────── */
  function buildFilterDrawer() {
    if (filterDrawerEl) return;
    filterDrawerEl = document.createElement('div');
    filterDrawerEl.id = 'hwl-filter-container';
    var frag = cloneTemplate('hwl-tpl-filter-drawer');
    if (frag) filterDrawerEl.appendChild(frag);
    document.body.appendChild(filterDrawerEl);
    filterDrawerEl.querySelector('.hwl-filter-overlay').addEventListener('click', closeFilterDrawer);
    filterDrawerEl.querySelector('.hwl-filter-close').addEventListener('click', closeFilterDrawer);
    filterDrawerEl.querySelector('.hwl-filter-apply').addEventListener('click', applyFilters);
    filterDrawerEl.querySelector('.hwl-filter-clear').addEventListener('click', clearFilters);

    /* Animate details open/close */
    filterDrawerEl.querySelectorAll('.hwl-filter-group').forEach(function (details) {
      var content = details.querySelector('.hwl-filter-group-content');
      details.querySelector('.hwl-filter-summary').addEventListener('click', function (e) {
        e.preventDefault();
        if (details.open && !details.classList.contains('is-closing')) {
          details.classList.add('is-closing');
          content.addEventListener('transitionend', function handler() {
            content.removeEventListener('transitionend', handler);
            details.classList.remove('is-closing');
            details.open = false;
          });
        } else if (!details.open) {
          details.open = true;
        }
      });
    });
  }

  function openFilterDrawer() {
    if (!filterDrawerEl) buildFilterDrawer();
    populateFilterOptions();
    filterDrawerEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeFilterDrawer() {
    if (!filterDrawerEl) return;
    filterDrawerEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function populateFilterOptions() {
    var colors = {};
    var sizes = {};
    /* Count from user's wishlist entries (each entry = one variant) */
    allWishlistItems.forEach(function (item) {
      if (item.color) colors[item.color] = (colors[item.color] || 0) + 1;
      if (item.size) sizes[item.size] = (sizes[item.size] || 0) + 1;
    });

    /* Color checkboxes */
    var colorContainer = filterDrawerEl.querySelector('#hwl-filter-colors');
    colorContainer.innerHTML = '';
    Object.keys(colors).forEach(function (c) {
      var label = document.createElement('label');
      label.className = 'hwl-filter-check';
      var checked = activeFilters.colors.indexOf(c) !== -1;
      label.innerHTML = '<input type="checkbox" value="' + c + '"' + (checked ? ' checked' : '') + '>' +
        c + '<span class="hwl-filter-check-count">(' + colors[c] + ')</span>';
      colorContainer.appendChild(label);
    });

    /* Size checkboxes */
    var sizeContainer = filterDrawerEl.querySelector('#hwl-filter-sizes');
    sizeContainer.innerHTML = '';
    Object.keys(sizes).forEach(function (s) {
      var label = document.createElement('label');
      label.className = 'hwl-filter-check';
      var checked = activeFilters.sizes.indexOf(s) !== -1;
      label.innerHTML = '<input type="checkbox" value="' + s + '"' + (checked ? ' checked' : '') + '>' +
        s + '<span class="hwl-filter-check-count">(' + sizes[s] + ')</span>';
      sizeContainer.appendChild(label);
    });

    /* Compute max price from wishlist variants */
    filterMaxPrice = 0;
    allWishlistItems.forEach(function (item) {
      var p = fetchedProductCache[item.productId];
      if (!p || !p.variants) return;
      var variant = p.variants.find(function (v) { return String(v.id) === String(item.variantId); });
      var price = variant ? Math.round(Number(variant.price) / 100) : 0;
      if (price > filterMaxPrice) filterMaxPrice = price;
    });

    /* Price range slider + inputs */
    var maxLabel = filterDrawerEl.querySelector('#hwl-price-max-label');
    var rangeMin = filterDrawerEl.querySelector('#hwl-range-min');
    var rangeMax = filterDrawerEl.querySelector('#hwl-range-max');
    var minInput = filterDrawerEl.querySelector('#hwl-price-min');
    var maxInput = filterDrawerEl.querySelector('#hwl-price-max');
    var rangeFill = filterDrawerEl.querySelector('#hwl-range-fill');

    if (maxLabel) maxLabel.textContent = '最高価格は¥' + filterMaxPrice.toLocaleString();

    if (rangeMin && rangeMax) {
      rangeMin.max = filterMaxPrice;
      rangeMax.max = filterMaxPrice;
      rangeMin.value = activeFilters.priceMin !== null ? activeFilters.priceMin : 0;
      rangeMax.value = activeFilters.priceMax !== null ? activeFilters.priceMax : filterMaxPrice;
      if (minInput) minInput.value = rangeMin.value;
      if (maxInput) maxInput.value = rangeMax.value;
      if (minInput) minInput.max = filterMaxPrice;
      if (maxInput) maxInput.max = filterMaxPrice;

      var updateFill = function () {
        var lo = Number(rangeMin.value);
        var hi = Number(rangeMax.value);
        var pctL = filterMaxPrice > 0 ? (lo / filterMaxPrice) * 100 : 0;
        var pctR = filterMaxPrice > 0 ? (hi / filterMaxPrice) * 100 : 100;
        if (rangeFill) {
          rangeFill.style.left = pctL + '%';
          rangeFill.style.width = (pctR - pctL) + '%';
        }
      };
      updateFill();

      rangeMin.oninput = function () {
        if (Number(rangeMin.value) > Number(rangeMax.value)) rangeMin.value = rangeMax.value;
        if (minInput) minInput.value = rangeMin.value;
        updateFill();
      };
      rangeMax.oninput = function () {
        if (Number(rangeMax.value) < Number(rangeMin.value)) rangeMax.value = rangeMin.value;
        if (maxInput) maxInput.value = rangeMax.value;
        updateFill();
      };
      if (minInput) {
        minInput.oninput = function () {
          var v = Number(minInput.value) || 0;
          if (v > filterMaxPrice) v = filterMaxPrice;
          rangeMin.value = v;
          if (v > Number(rangeMax.value)) { rangeMax.value = v; if (maxInput) maxInput.value = v; }
          updateFill();
        };
      }
      if (maxInput) {
        maxInput.oninput = function () {
          var v = Number(maxInput.value) || 0;
          if (v > filterMaxPrice) v = filterMaxPrice;
          rangeMax.value = v;
          if (v < Number(rangeMin.value)) { rangeMin.value = v; if (minInput) minInput.value = v; }
          updateFill();
        };
      }
    }

    /* Availability */
    var avails = filterDrawerEl.querySelectorAll('#hwl-filter-availability input');
    avails.forEach(function (cb) {
      if (cb.value === 'in_stock') cb.checked = activeFilters.inStock;
      if (cb.value === 'sold_out') cb.checked = activeFilters.soldOut;
    });
  }

  function applyFilters() {
    /* Read state from drawer */
    activeFilters.colors = Array.from(filterDrawerEl.querySelectorAll('#hwl-filter-colors input:checked'))
      .map(function (cb) { return cb.value; });

    activeFilters.sizes = Array.from(filterDrawerEl.querySelectorAll('#hwl-filter-sizes input:checked'))
      .map(function (cb) { return cb.value; });

    var minVal = Number(filterDrawerEl.querySelector('#hwl-price-min').value) || 0;
    var maxVal = Number(filterDrawerEl.querySelector('#hwl-price-max').value) || 0;
    /* Treat full range as no filter */
    activeFilters.priceMin = minVal > 0 ? minVal : null;
    activeFilters.priceMax = (maxVal > 0 && maxVal < filterMaxPrice) ? maxVal : null;

    var avails = filterDrawerEl.querySelectorAll('#hwl-filter-availability input');
    avails.forEach(function (cb) {
      if (cb.value === 'in_stock') activeFilters.inStock = cb.checked;
      if (cb.value === 'sold_out') activeFilters.soldOut = cb.checked;
    });

    closeFilterDrawer();
    var root = document.getElementById('react-wishlist-root');
    if (root) {
      renderProductCards(root, allWishlistItems);
      renderFilterTags(root);
    }
  }

  function clearFilters() {
    activeFilters = { colors: [], sizes: [], priceMin: null, priceMax: null, inStock: false, soldOut: false };
    populateFilterOptions();
    var root = document.getElementById('react-wishlist-root');
    if (root) {
      renderProductCards(root, allWishlistItems);
      renderFilterTags(root);
      updateFilterBadge(root);
    }
  }

  function getActiveFilterCount() {
    var count = 0;
    if (activeFilters.colors.length > 0) count += activeFilters.colors.length;
    if (activeFilters.sizes.length > 0) count += activeFilters.sizes.length;
    if (activeFilters.priceMin !== null || activeFilters.priceMax !== null) count++;
    if (activeFilters.inStock) count++;
    if (activeFilters.soldOut) count++;
    return count;
  }

  function updateFilterBadge(root) {
    var btn = root.querySelector('.hwl-page-filter-btn');
    if (!btn) return;
    var badge = btn.querySelector('.hwl-filter-badge');
    var count = getActiveFilterCount();
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'hwl-filter-badge';
        btn.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function renderFilterTags(root) {
    var container = root.querySelector('#hwl-filter-tags');
    if (!container) return;
    container.innerHTML = '';
    var tags = [];

    activeFilters.colors.forEach(function (c) {
      tags.push({ label: c, type: 'color', value: c });
    });
    activeFilters.sizes.forEach(function (s) {
      tags.push({ label: s, type: 'size', value: s });
    });
    if (activeFilters.priceMin !== null || activeFilters.priceMax !== null) {
      var label = '¥' + (activeFilters.priceMin || 0).toLocaleString() + ' 〜 ' +
        (activeFilters.priceMax !== null ? '¥' + activeFilters.priceMax.toLocaleString() : '');
      tags.push({ label: label, type: 'price', value: 'price' });
    }
    if (activeFilters.inStock) {
      tags.push({ label: i18n.wishlistFilterInStock, type: 'avail', value: 'in_stock' });
    }
    if (activeFilters.soldOut) {
      tags.push({ label: i18n.wishlistFilterSoldOut, type: 'avail', value: 'sold_out' });
    }

    tags.forEach(function (tag) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'hwl-filter-tag';
      el.innerHTML = tag.label + ' <span class="hwl-filter-tag-x">\u00d7</span>';
      el.addEventListener('click', function () {
        removeFilterTag(tag.type, tag.value);
        renderProductCards(root, allWishlistItems);
        renderFilterTags(root);
        updateFilterBadge(root);
      });
      container.appendChild(el);
    });
  }

  function removeFilterTag(type, value) {
    if (type === 'color') {
      activeFilters.colors = activeFilters.colors.filter(function (c) { return c !== value; });
    } else if (type === 'size') {
      activeFilters.sizes = activeFilters.sizes.filter(function (s) { return s !== value; });
    } else if (type === 'price') {
      activeFilters.priceMin = null;
      activeFilters.priceMax = null;
    } else if (type === 'avail') {
      if (value === 'in_stock') activeFilters.inStock = false;
      if (value === 'sold_out') activeFilters.soldOut = false;
    }
  }

  function filterItems(items) {
    return items.filter(function (item) {
      var p = fetchedProductCache[item.productId];
      if (!p) return true; /* no data yet, show it */
      var variant = p.variants && p.variants.find(function (v) { return String(v.id) === String(item.variantId); });

      /* Availability — only filter when at least one option is checked */
      if (activeFilters.inStock || activeFilters.soldOut) {
        var avail = variant ? variant.available : p.available;
        if (!activeFilters.inStock && avail) return false;
        if (!activeFilters.soldOut && !avail) return false;
      }

      /* Price (variant-specific) */
      var price = variant ? Number(variant.price) / 100 : (p.price_min ? Number(p.price_min) / 100 : 0);
      if (activeFilters.priceMin !== null && price < activeFilters.priceMin) return false;
      if (activeFilters.priceMax !== null && price > activeFilters.priceMax) return false;

      /* Color */
      if (activeFilters.colors.length > 0) {
        if (!item.color || activeFilters.colors.indexOf(item.color) === -1) return false;
      }

      /* Size */
      if (activeFilters.sizes.length > 0) {
        if (!item.size || activeFilters.sizes.indexOf(item.size) === -1) return false;
      }

      return true;
    });
  }

  function formatPrice(price) {
    /* Shopify .js API returns price in subunit (cents), e.g. 396000 = ¥3,960 */
    return '¥' + Math.round(Number(price) / 100).toLocaleString();
  }

  function renderWishlistPage() {
    var root = document.getElementById('react-wishlist-root');
    if (!root) return;

    var items = Array.from(window.heartWishlist.values());
    var totalItems = items.length;

    /* Empty state */
    if (totalItems === 0) {
      root.innerHTML = '';
      var emptyFrag = cloneTemplate('hwl-tpl-page-empty');
      if (emptyFrag) root.appendChild(emptyFrag);
      return;
    }

    /* Page shell from template */
    root.innerHTML = '';
    var shellFrag = cloneTemplate('hwl-tpl-page-shell');
    if (!shellFrag) return;

    /* Set dynamic values */
    shellFrag.querySelector('.hwl-page-item-count').textContent = totalItems + ' ' + i18n.wishlistItemCount;

    /* Restore sort/view state */
    var sortEl = shellFrag.querySelector('#hwl-sort');
    if (sortEl && currentSort !== 'recommend') {
      var opt = sortEl.querySelector('[value="' + currentSort + '"]');
      if (opt) opt.selected = true;
    }
    shellFrag.querySelectorAll('.hwl-page-view-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.view === currentView);
    });

    /* Restore grid view class so re-renders keep the user's chosen view */
    var shellGrid = shellFrag.querySelector('#hwl-page-grid');
    if (shellGrid && currentView === 'list') {
      shellGrid.classList.add('hwl-page-grid--list');
    }

    root.appendChild(shellFrag);

    /* Insert skeleton cards (one per item) */
    var skGrid = root.querySelector('#hwl-page-grid');
    var skeletonCount = Math.min(items.length, 8);
    for (var si = 0; si < skeletonCount; si++) {
      var skFrag = cloneTemplate('hwl-tpl-skeleton-card');
      if (skFrag) skGrid.appendChild(skFrag);
    }

    /* Bind toolbar events */
    var filterBtn = root.querySelector('.hwl-page-filter-btn');
    if (filterBtn) {
      filterBtn.addEventListener('click', openFilterDrawer);
    }

    var sortSelect = root.querySelector('#hwl-sort');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        currentSort = sortSelect.value;
        renderProductCards(root, allWishlistItems);
      });
    }
    root.querySelectorAll('.hwl-page-view-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentView = btn.dataset.view;
        root.querySelectorAll('.hwl-page-view-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var grid = root.querySelector('#hwl-page-grid');
        if (grid) {
          grid.classList.remove('hwl-page-grid--list');
          if (currentView === 'list') grid.classList.add('hwl-page-grid--list');
        }
      });
    });

    /* Deduplicate fetches by productId — each unique product fetched once */
    var uniqueProducts = {};
    items.forEach(function (item) {
      if (!uniqueProducts[item.productId]) {
        uniqueProducts[item.productId] = { productId: item.productId, handle: item.handle, title: item.title };
      }
    });
    /* Kick off browser image fetch as soon as we know URLs — runs in parallel
       with remaining product fetches and DOM build, so cards paint with images
       already (or partially) loaded. */
    function preloadVariantImages(product) {
      if (!product || !product.variants) return;
      var pid = String(product.id);
      items.forEach(function (item) {
        if (item.productId !== pid) return;
        var variant = product.variants.find(function (v) { return String(v.id) === String(item.variantId); });
        var raw = '';
        if (variant && variant.featured_image) {
          raw = typeof variant.featured_image === 'string' ? variant.featured_image : (variant.featured_image.src || '');
        }
        if (!raw && product.featured_image) raw = product.featured_image;
        if (raw) {
          var pre = new Image();
          pre.src = raw.replace(/\.(jpg|jpeg|png|webp)/, '_400x.$1');
        }
      });
    }

    var fetchPromises = Object.values(uniqueProducts).map(function (prod) {
      if (fetchedProductCache[prod.productId]) {
        preloadVariantImages(fetchedProductCache[prod.productId]);
        return Promise.resolve(fetchedProductCache[prod.productId]);
      }

      /* Strategy 1: fetch by handle (shared fetch dedupes/caches) */
      if (prod.handle) {
        return fetchProduct(prod.handle)
          .then(function (product) {
            if (product && product.id) {
              fetchedProductCache[prod.productId] = product;
              preloadVariantImages(product);
              return product;
            }
            return null;
          })
          .catch(function () { return null; });
      }

      /* Strategy 2: search by title when handle is missing */
      if (prod.title) {
        return fetch('/search/suggest.json?q=' + encodeURIComponent(prod.title) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var results = data && data.resources && data.resources.results && data.resources.results.products;
            if (!results || results.length === 0) return null;
            var match = results[0];
            var handle = match.handle || (match.url ? match.url.split('/products/')[1] : null);
            if (!handle) return null;
            /* Backfill handle into wishlist entries */
            Array.from(window.heartWishlist.entries()).forEach(function (entry) {
              if (entry[1].productId === prod.productId && !entry[1].handle) {
                entry[1].handle = handle;
                window.heartWishlist.set(entry[0], entry[1]);
              }
            });
            save();
            return fetchProduct(handle)
              .then(function (product) {
                if (product && product.id) {
                  fetchedProductCache[prod.productId] = product;
                  preloadVariantImages(product);
                  return product;
                }
                return null;
              });
          })
          .catch(function () { return null; });
      }

      return Promise.resolve(null);
    });

    Promise.all(fetchPromises).then(function () {
      /* Drop items whose product fetch failed */
      var validItems = items.filter(function (item) { return !!fetchedProductCache[item.productId]; });
      allWishlistItems = validItems;

      var countEl = root.querySelector('.hwl-page-item-count');
      if (countEl) countEl.textContent = validItems.length + ' ' + i18n.wishlistItemCount;

      renderProductCards(root, validItems);
    });
  }

  function renderProductCards(root, items) {
    var grid = root.querySelector('#hwl-page-grid');
    if (!grid) return;

    /* Filter then sort */
    var sorted = filterItems(items);
    if (currentSort === 'price_asc' || currentSort === 'price_desc') {
      sorted.sort(function (a, b) {
        var pa = fetchedProductCache[a.productId];
        var pb = fetchedProductCache[b.productId];
        var va = pa && pa.variants && pa.variants.find(function (v) { return String(v.id) === String(a.variantId); });
        var vb = pb && pb.variants && pb.variants.find(function (v) { return String(v.id) === String(b.variantId); });
        var priceA = va ? parseFloat(va.price) : (pa ? parseFloat(pa.price_min || pa.price || 0) : 0);
        var priceB = vb ? parseFloat(vb.price) : (pb ? parseFloat(pb.price_min || pb.price || 0) : 0);
        return currentSort === 'price_asc' ? priceA - priceB : priceB - priceA;
      });
    } else if (currentSort === 'newest') {
      sorted.reverse();
    }

    grid.innerHTML = '';
    sorted.forEach(function (item) {
      var shopifyProduct = fetchedProductCache[item.productId];
      var variant = shopifyProduct && shopifyProduct.variants
        ? shopifyProduct.variants.find(function (v) { return String(v.id) === String(item.variantId); })
        : null;

      var href = item.handle ? '/products/' + item.handle : '#';
      var imgSrc = '';
      var vendor = '';
      var price = '';
      var compareAtPrice = '';
      var isSoldOut = false;

      if (shopifyProduct) {
        /* Prefer variant featured image, fallback to product featured image */
        var variantImg = variant && variant.featured_image
          ? (typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src)
          : null;
        if (variantImg) {
          imgSrc = variantImg.replace(/\.(jpg|png|webp)/, '_400x.$1');
        } else if (shopifyProduct.featured_image) {
          imgSrc = shopifyProduct.featured_image.replace(/\.(jpg|png|webp)/, '_400x.$1');
        } else if (shopifyProduct.images && shopifyProduct.images[0]) {
          var img = typeof shopifyProduct.images[0] === 'string' ? shopifyProduct.images[0] : shopifyProduct.images[0].src;
          imgSrc = img.replace(/\.(jpg|png|webp)/, '_400x.$1');
        }
        vendor = shopifyProduct.vendor || '';
        if (variant) {
          price = variant.price;
          compareAtPrice = variant.compare_at_price || '';
          isSoldOut = !variant.available;
        } else if (shopifyProduct.variants && shopifyProduct.variants[0]) {
          /* Variant no longer exists — fall back to product's first variant */
          price = shopifyProduct.variants[0].price;
          compareAtPrice = shopifyProduct.variants[0].compare_at_price || '';
          isSoldOut = !shopifyProduct.available;
        }
      }

      var isOnSale = compareAtPrice && parseFloat(compareAtPrice) > parseFloat(price);

      /* Clone template and populate */
      var cardFrag = cloneTemplate('hwl-tpl-page-card');
      if (!cardFrag) return;
      var card = cardFrag.querySelector('.hwl-page-card');
      card.dataset.productId = item.productId;
      card.dataset.productVariantId = item.variantId;

      /* Image + links */
      card.querySelectorAll('a').forEach(function (a) { a.href = href; });
      var cardImg = card.querySelector('.hwl-page-card-img');
      cardImg.src = imgSrc;
      cardImg.alt = item.title || '';

      /* Heart — cache full entry data so we can re-add after a local remove */
      var heartBtn = card.querySelector('.hwl-page-card-heart');
      heartBtn.dataset.productId = item.productId;
      heartBtn.dataset.productVariantId = item.variantId;
      heartBtn.dataset.itemColor = item.color || '';
      heartBtn.dataset.itemSize = item.size || '';
      heartBtn.dataset.itemTitle = item.title || '';
      heartBtn.dataset.itemHandle = item.handle || '';
      heartBtn.classList.add('is-liked'); /* initial state — item is in wishlist */

      /* Vendor */
      var vendorEl = card.querySelector('.hwl-page-card-vendor');
      if (vendor) { vendorEl.textContent = vendor; } else { vendorEl.remove(); }

      /* Title */
      card.querySelector('.hwl-page-card-title').textContent = item.title || '';

      /* Size tag — only show when item has a real size (not the variant.title
         fallback that equals the color). Detect legacy data where size was
         saved as the color value: skip if size matches color or if the product
         has no Size option in its options. */
      var variantsEl = card.querySelector('.hwl-page-card-variants');
      var hasSizeOption = false;
      if (shopifyProduct && shopifyProduct.options) {
        for (var oi = 0; oi < shopifyProduct.options.length; oi++) {
          var optName = (typeof shopifyProduct.options[oi] === 'string'
            ? shopifyProduct.options[oi]
            : shopifyProduct.options[oi].name || ''
          ).toLowerCase();
          if (optName === 'size' || optName === 'サイズ' || optName === 'taille' || optName === 'größe' || optName === '尺寸' || optName === '사이즈') {
            hasSizeOption = true;
            break;
          }
        }
      }
      var showSize = item.size && hasSizeOption && item.size !== item.color;
      if (showSize) {
        var sizeTag = document.createElement('p');
        sizeTag.className = 'hwl-page-card-variant-line';
        sizeTag.textContent = i18n.wishlistSizeLabel + item.size;
        variantsEl.appendChild(sizeTag);
      } else {
        variantsEl.remove();
      }

      /* Price — sale stays red (sale class), regular black. No compare-at strikethrough. */
      var priceEl = card.querySelector('.hwl-page-card-price');
      if (price) {
        var priceClass = isOnSale ? 'hwl-page-card-price-sale' : 'hwl-page-card-price-regular';
        priceEl.innerHTML = '<span class="' + priceClass + '">' + formatPrice(price) + '</span>';
      }

      /* Cart button (grid) */
      var cartBtn = card.querySelector('.hwl-page-card-cart-btn');
      if (isSoldOut) {
        cartBtn.classList.add('is-sold-out');
        cartBtn.disabled = true;
        cartBtn.textContent = i18n.wishlistSoldOut;
      } else {
        cartBtn.dataset.productId = item.productId;
        cartBtn.dataset.variantId = item.variantId;
        cartBtn.textContent = i18n.wishlistAddToCart;
      }

      /* Cart button (list) */
      var listCart = card.querySelector('.hwl-page-card-list-cart');
      if (isSoldOut) {
        listCart.classList.add('is-sold-out');
        listCart.disabled = true;
        listCart.textContent = i18n.wishlistSoldOut;
      } else {
        listCart.dataset.productId = item.productId;
        listCart.dataset.variantId = item.variantId;
        listCart.textContent = i18n.wishlistAddToCartLong;
      }

      grid.appendChild(cardFrag);
    });

    /* Update item count after filter */
    var countEl = root.querySelector('.hwl-page-item-count');
    if (countEl) countEl.textContent = sorted.length + ' ' + i18n.wishlistItemCount;

    /* Update filter badge */
    updateFilterBadge(root);

    /* Bind heart on wishlist page: toggle in place (don't re-render).
       Card stays visible — heart changes red ↔ outline. Toggle calls API
       (add/delete) normally. Page reload removes the unfavorited cards. */
    grid.querySelectorAll('.hwl-page-card-heart').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pid = btn.dataset.productId;
        var vid = btn.dataset.productVariantId;
        var key = variantKey(pid, vid);
        /* Read from cached dataset — works even after a previous remove */
        var color = btn.dataset.itemColor || '';
        var size = btn.dataset.itemSize || '';
        var title = btn.dataset.itemTitle || '';
        var handle = btn.dataset.itemHandle || '';
        toggleVariant(key, pid, vid, color, size, title, handle);
        /* Update local visual state — no re-render, card stays in DOM */
        var nowLiked = window.heartWishlist.has(key);
        btn.classList.toggle('is-liked', nowLiked);
        btn.setAttribute('aria-pressed', String(nowLiked));
      });
    });

    /* Bind add-to-cart buttons (grid + list) — uses the saved variant directly */
    grid.querySelectorAll('.hwl-page-card-cart-btn, .hwl-page-card-list-cart').forEach(function (btn) {
      if (btn.classList.contains('is-sold-out')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var pid = btn.dataset.productId;
        var vid = btn.dataset.variantId;
        var product = fetchedProductCache[pid];
        if (!product || !product.variants) return;
        var variant = product.variants.find(function (v) { return String(v.id) === String(vid) && v.available; });
        if (!variant) return;

        if (btn.getAttribute('aria-disabled') === 'true') return;
        btn.setAttribute('aria-disabled', 'true');

        var formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', '1');

        fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (r) {
            return r.json().then(function (parsed) {
              if (!r.ok || parsed.status) throw parsed;
              return parsed;
            });
          })
          .then(function (parsedState) {
            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'ac_add_to_cart',
                source: 'wishlist',
                variant_id: parsedState.id,
                product_id: parsedState.product_id,
                quantity: 1,
                value: parsedState.price
              });
            }

            if (!window.ACCartModal || !window.ACCartModal.canShow() || wishlistOverlayOpen()) {
              window.location.href = cartUrl();
              return;
            }

            btn.removeAttribute('aria-disabled');
            window.ACCartModal.show(parsedState, btn);
            refreshCartCount();
          })
          .catch(function (err) {
            btn.removeAttribute('aria-disabled');
            console.error('[heart-wishlist] add to cart failed', err);
          });
      });
    });
  }

  function wishlistOverlayOpen() {
    var modalEl = document.getElementById('hwl-modal');
    if (modalEl && !modalEl.classList.contains('hwl-hidden')) return true;

    var toast = document.getElementById('hwl-toast');
    if (toast && !toast.classList.contains('hwl-toast--hidden')) return true;

    var filters = document.getElementById('hwl-filter-container');
    return !!filters && filters.classList.contains('is-open');
  }

  function cartUrl() {
    var theme = window.FoxTheme;
    return (theme && theme.routes && theme.routes.cart_url) || '/cart';
  }

  function cartAddUrl() {
    var theme = window.FoxTheme;
    return (theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js';
  }

  function refreshCartCount() {
    var theme = window.FoxTheme;

    fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart refresh returned ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        if (theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        }
      })
      .catch(function (err) {
        console.error('[heart-wishlist] cart refresh failed', err);
      });
  }

  /* ── Hide Wishlist Hero ──────────────────────────────────────── */
  function hideWishlistHero() {
    document.querySelectorAll('.wh-abs-pin, .wishlist-hero-custom-button, [class*="wishlisthero"]')
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
  }

  /* ── Init ─────────────────────────────────────────────────────── */
  function initAll() {
    indexEmbeddedProducts();
    migrateHandleEntries();
    initHeartButtons();
    initDetailWishlistBtns();
    injectRankingHearts();
    refreshHeaderIcon();
    renderWishlistPage();
    hideWishlistHero();

    /* Sync with server for logged-in users */
    if (customerId) {
      syncToServer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Debounced observer — Shopify pages have constant DOM mutations (lazy load,
     animations, third-party apps). Running on every mutation overloads the
     network with /products/*.js fetches → Cloudflare bot protection trips. */
  var observerTimer = null;
  var observer = new MutationObserver(function (mutations) {
    /* Only react if NEW nodes were added (skip attribute-only mutations) */
    var hasAddedNodes = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
        hasAddedNodes = true;
        break;
      }
    }
    if (!hasAddedNodes) return;
    if (observerTimer) return; /* a tick is already scheduled */
    observerTimer = setTimeout(function () {
      observerTimer = null;
      indexEmbeddedProducts();
      initHeartButtons();
      initDetailWishlistBtns();
      injectRankingHearts();
      hideWishlistHero();
    }, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* Slider/ranking-app retries — fewer, spaced wider to avoid request bursts */
  setTimeout(function () {
    initHeartButtons();
    injectRankingHearts();
    hideWishlistHero();
  }, 1500);
  setTimeout(function () {
    initHeartButtons();
    injectRankingHearts();
  }, 4000);
})();
